<script>
  export let value;
</script>

<div class="font-mono">
  {value}
</div>
